// extracted by mini-css-extract-plugin
export default {"performerPageBanner":"PerformerPageBanner_performerPageBanner__P9wdR","title":"PerformerPageBanner_title__EHKoq"};